export default __webpack_public_path__ + "static/media/sliderThumb.42b90c45.svg";